import FallbackPage from '@/components/pages/worker/portal/FallbackPage';

export default function Page() {
  return <FallbackPage empty />;
}
